import { apiClient } from "./apiClient";

export type SecretType = "news" | "ai" | "exchange" | "data" | "notification" | "other";

export type SecretMetadata = {
  secretId: string;
  label: string;
  secretType: SecretType;
  createdAt: string;
  updatedAt: string;
  maskedValue: string;
  metadata: Record<string, unknown>;
};

export async function createSecret(input: {
  secretId: string;
  label?: string;
  secretType: SecretType;
  value: string;
  metadata?: Record<string, unknown>;
}): Promise<SecretMetadata> {
  const response = await apiClient.post<SecretMetadata>("/security/secrets", input);
  return response.data;
}

export async function updateSecret(
  secretId: string,
  input: {
    label?: string;
    value?: string;
    metadata?: Record<string, unknown>;
  },
): Promise<SecretMetadata> {
  const response = await apiClient.put<SecretMetadata>(
    `/security/secrets/${secretId}`,
    input,
  );
  return response.data;
}

export async function deleteSecret(secretId: string): Promise<void> {
  await apiClient.delete(`/security/secrets/${secretId}`);
}
